<div class="createcontact-modal-container">
  <form #addcontactForm="ngForm" appFocusOnErrorField (ngSubmit)="saveContactInfo(addcontactForm)" class="times-log-form" novalidate>
    <div class="col-sm-12 p-0">
      <div class="createcontact-modal">
        <div class="cmn-modal-header">
          <h4 class="modal-header-title">{{buttontext}} contact</h4>
        </div>
        <div class="cmn-modal-content">
          <h5 class="contactinfo-title">Contact information</h5>
          <!-- basic info -->
          <div class="basic-info-container">
            <h4 class="createcontact-section-title">Basic info</h4>
            <div class="createcontact-section-row">
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">Title</h6>
                  <div class="col-3">
                    <div class="form-select-container">
                      <ng-select [items]="titleList" class="cmn-ngselect"
                                 bindLabel="title"
                                 bindValue="title"
                                 [clearable]="true" id="title" name="title" #title="ngModel"
                                 placeholder="Select Title" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.title" data-testid="drpdwn-contact-title">

                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          <span class=""> {{item.title.length > 15 ? (item.title| slice:0:15) + '..' : item.title}}</span>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Name<span class="error-text">*</span>
                  </h6>
                  <div class="col-3">
                    <div class="form-input-container">
                      <input type="text" class="form-control" maxlength="128" name="firstname" #firstName1="ngModel" autocomplete="off" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.firstName" placeholder="Enter first name*" required [ngClass]="{'is-invalid':addcontactForm.submitted && firstName1.invalid }" data-testid="input-first-name-contact" />
                      <div *ngIf="addcontactForm.submitted && firstName1.invalid" class="invalid-feedback invalid postion_kc_absloue_kc">
                        <div *ngIf="firstName1.errors.required">
                          First name is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-input-container">
                      <input type="text" class="form-control" maxlength="128" autocomplete="off" name="middleName" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.middleName" placeholder="Enter middle name" data-testid="input-middle-name-contact" />
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-input-container">
                      <input type="text" class="form-control" maxlength="128" autocomplete="off" name="lastname" #lastname1="ngModel" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.lastname" placeholder="Enter last name*" required [ngClass]="{'is-invalid':addcontactForm.submitted && lastname1.invalid }" data-testid="input-last-name-contact" />
                      <div *ngIf="addcontactForm.submitted && lastname1.invalid" class="invalid-feedback invalid postion_kc_absloue_kc">
                        <div *ngIf="lastname1.errors.required">
                          Last name is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Salutation<span class="error-text">*</span>
                  </h6>
                  <div class="col-9">
                    <div class="form-input-container">
                      <input type="text" class="form-control" name="salutation" data-testid="input-salutation-contact" autocomplete="off" #salutation="ngModel" maxlength="404" [(ngModel)]="contactDataModal.salutation" placeholder="Enter salutation" required [ngClass]="{'is-invalid':addcontactForm.submitted && salutation.invalid }"/>
                        <div *ngIf="addcontactForm.submitted && salutation.invalid" class="invalid-feedback invalid position_kc_step">
                        <div *ngIf="salutation.errors.required">
                          Salutation is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Preferred name
                  </h6>
                  <div class="col-9">
                    <div class="form-input-container">
                      <input type="text"
                             class="form-control" name="preferredname" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.preferredname"
                             placeholder="Enter preferred name" autocomplete="off" data-testid="input-preferred-name-contact"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    DIN
                  </h6>

                  <!--DIN element in Add Mode Start-->
                  <div class="col-3" *ngIf="!isEditMode">
                    <div class="form-input-container" *ngIf="!isContactPrivacy && !isShowDIN" (click)="ShowDIN();">
                      Not Recorded
                    </div>
                    <div class="form-input-container" *ngIf="(isContactPrivacy && !isShowDIN) || (!isContactPrivacy && isShowDIN )">
                      <input type="text" class="form-control" name="DIN" mask="00000 - 00000 - 00000" autocomplete="off" [(ngModel)]="contactDataModal.din" placeholder="00000 - 00000 - 00000" (blur)="DINValidate();$event.preventDefault();" data-testid="input-din-contact" />
                      <div *ngIf="(addcontactForm.submitted && _dinValidateStatus) || _dinValidateStatus" class="invalid-feedback invalid">
                        DIN is invalid
                      </div>
                    </div>
                  </div>
                  <!--DIN element in Add Mode End-->
                  <!--DIN element in Edit Mode Start-->
                  <div class="col-3" *ngIf="isEditMode">
                    <div class="form-input-container" *ngIf="((!isContactPrivacy && !isShowDIN) || (isContactPrivacy && !isShowDIN)) && (contactDataModal.din == '' || contactDataModal.din == undefined )" (click)="ShowDIN();">
                      Not recorded
                    </div>
                    <div class="form-input-container" *ngIf="((!isContactPrivacy && !isShowDIN) || (isContactPrivacy && !isShowDIN)) && contactDataModal.din != '' && contactDataModal.din != undefined " (click)="ShowDIN();">
                      Recorded
                    </div>
                    <div class="form-input-container" *ngIf="isContactPrivacy && isShowDIN">
                      <input type="text" class="form-control" name="DIN" mask="00000 - 00000 - 00000" autocomplete="off" [(ngModel)]="contactDataModal.din" placeholder="00000 - 00000 - 00000" (blur)="DINValidate();$event.preventDefault();" data-testid="input-din-contact-alt"/>
                      <div *ngIf="(contactDataModal.submitted && _dinValidateStatus) || _dinValidateStatus" class="invalid-feedback invalid">
                        DIN is invalid
                      </div>
                    </div>
                    <div class="form-input-container" *ngIf="!isContactPrivacy && isShowDIN">
                      <input type="text" class="form-control" name="DIN" mask="00000 - 00000 - 00000" autocomplete="off" [(ngModel)]="noPermissionDINData" placeholder="00000 - 00000 - 00000" (blur)="DINValidateInNoPriacyPermission();$event.preventDefault();" data-testid="input-din-contact-no-prmsn" />
                      <div *ngIf="(contactDataModal.submitted && _dinValidateStatus) || _dinValidateStatus" class="invalid-feedback invalid">
                        DIN is invalid
                      </div>
                    </div>
                  </div>
                  <!--DIN element in Edit Mode End-->

                </div>
              </div>
              <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                context: { label: 'Date of birth', name: 'dateOfBirth', max: maxDate, dataTestid: 'datepkr-date-of-birth', changeHandler: checkOnchangefield, maxValueName: 'dateOfDeath' }">
              </ng-container>
              <ng-container *ngTemplateOutlet="commonDatepickerTemplate;
                context: { label: 'Date of death', name: 'dateOfDeath', min: 'dateOfBirth', max: maxDate, dataTestid: 'datepkr-date-of-death', changeHandler: checkOnchangefield }">
              </ng-container>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Place  of  birth
                  </h6>
                  <div class="col-3">
                    <div class="form-input-container">
                      <input type="text"
                             class="form-control" name="placeOfBirth" maxlength="128" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.placeOfBirth"
                             placeholder="Enter place of birth" autocomplete="off" data-testid="input-place-of-birth"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Gender
                  </h6>
                  <div class="col-3">
                    <div class="form-select-create-contact create_contact_test">
                      <select class="form-control" name="gender" (change)="checkOnchangefield();" [(ngModel)]="contactDataModal.gender" data-testid="drpdwn-gender-contact">
                        <option value=undefined selected="selected" disabled>Select gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Unspecified">Unspecified</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <!-- basic info end -->
          <!-- Contact info -->
          <div class="Contact-info-container">
            <h4 class="createcontact-section-title">Contact</h4>
            <div class="createcontact-section-row">
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center mt-4" *ngFor="let row of emails; let i = index">
                  <!-- Label -->
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">Email</h6>
                  <!-- Email Type -->
                  <div class="col-2 form-select-container">
                    <div class="arrowicon normal-form-select-arrow">
                      <select class="form-control"
                              [(ngModel)]="row.emailTypeId"
                              name="emailType{{ i }}"
                              (focus)="onDropdownOpenEmail(row)"
                              (change)="setEmailPreferredAndImportant(i, row.email)" data-testid="drpdwn-email-type">

                        <option *ngFor="let item of emailTypes"
                                [ngValue]="item.emailTypeId"
                                [disabled]="isEmailTypeDisabled(item)">
                          {{ item.emailTypeName }}
                          <span *ngIf="isEmailTypeDisabled(item)"> (Max 5 reached)</span>
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Email Input -->
                  <div class="col-4 form-input-container">
                    <input type="email"
                           class="form-control"
                           placeholder="Enter email"
                           [(ngModel)]="row.emailId"
                           [ngModelOptions]="{ standalone: true }"
                           [class.is-invalid]="row.touched && row.emailId && !isValidEmail(row.emailId)"
                           (blur)="onEmailBlur(i, row)"
                           data-testid="input-email-type">
                    <div class="invalid-emailphone-feedback position_kc_step"
                         *ngIf="row.emailId && !isValidEmail(row.emailId)">
                      Please enter a valid email
                    </div>
                  </div>

                  <!-- Actions -->
                  <div class="col-3 d-flex align-items-center">
                    <!-- Preferred -->
                    <div class="add-row-start" *ngIf="row.isPreferred">
                      <a (click)="setPreferredEmail(i, false, true)" class="cursor-pointer" data-testid="lnk-preferred-email">
                        <img src="../../../../assets/img/ArrowBlueIcon/Preffered blue.svg" alt="imgPreferred" class="width-preffred-icon">
                      </a>
                    </div>
                    <div class="add-row-start" *ngIf="!row.isPreferred">
                      <a (click)="setPreferredEmail(i, true, true)" class="cursor-pointer" data-testid="lnk-non-preferred-email">
                        <img src="../../../../assets/img/ArrowBlueIcon/Preffered.svg" alt="imgPreferred" class="width-preffred-icon">
                      </a>
                    </div>
                    <div class="add-row-start" *ngIf="row.isFavourite">
                      <a (click)="setStartedEmail(i, false, true)" class="cursor-pointer" data-testid="lnk-favourite-email">
                        <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" alt="imgstarticon" class="width-star-icon">
                      </a>
                    </div>
                    <div class="add-row-start" *ngIf="!row.isFavourite">
                      <a (click)="setStartedEmail(i, true, true)" class="cursor-pointer" data-testid="lnk-non-favourite-email">
                        <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" alt="imgstarticon" class="width-star-icon">
                      </a>
                    </div>

                    <!-- Remove -->
                    <div class="add-row-btn">
                      <a (click)="removeEmail(i, row)"
                         class="cursor-pointer ml-2"
                         *ngIf="emails.length > 1" data-testid="btn-remove-email">
                        <img src="../../../../assets/img/client/filter-icon/delete.svg">
                      </a>
                    </div>

                    <!-- Add -->
                    <button *ngIf="i === emails.length - 1 && emails.length < getMaxAllowedEmails()"
                            class="cmn-inverse-btn ml-2"
                            (click)="addEmail(); $event.preventDefault()" data-testid="btn-add-email-contact">
                      + Email
                    </button>

                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm" *ngIf="phones.length > 0">
                <div class="custom-row align-items-start mt-4" *ngFor="let row of phones; let i = index">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd"> Phone</h6>
                  <div class="col-2 form-select-container">
                    <div class="arrowicon normal-form-select-arrow">
                      <select class="form-control"
                              [(ngModel)]="row.phoneTypeId"
                              name="phoneType{{ i }}"
                              (focus)="onDropdownOpenPhone(row)"
                              (change)="setPhonePreferredAndImportant(i, row.phone)"
                              data-testid="drpdwn-phone-type">

                        <option *ngFor="let item of phoneTypes"
                                [ngValue]="item.phoneTypeId"
                                [disabled]="isPhoneTypeDisabled(item)">
                          {{ item.phoneTypeName }}
                          <span *ngIf="isPhoneTypeDisabled(item)"> (Max 5 reached)</span>
                        </option>

                      </select>
                    </div>
                  </div>

                  <div class="col-4 phone-number-container d-flex align-items-center">
                    <div class="phone-combined-field d-flex align-items-center">
                    <div class="phone-country-code-container form-select-filter-container settings-temp-tbl-select">
                      <ejs-dropdownlist id="ddlelement"
                          #samples
                          [dataSource]="countries"
                          cssClass="cmn-filter-dropdown"
                          [query]="query"
                          [fields]="countryfields"
                          [placeholder]="country"
                          [allowFiltering]="true"
                          [sortOrder]="sorting"
                          (change)="onCountryCodeChange(i, $event, row)"
                          [(ngModel)]="row.countryId"
                          name="countryId{{ i }}"
                          data-testid="drpdwn-lst-phone-country-code">

                          <!-- Dropdown list items -->
                          <ng-template #itemTemplate let-data>
                              {{ data.name }} {{ data.isdCode }}
                          </ng-template>

                          <!-- Selected value -->
                          <ng-template #valueTemplate let-data>
                              {{ data.isdCode }}
                          </ng-template>

                      </ejs-dropdownlist>
                    </div>
                    <div class="form-input-container phone-number-input-container border-left-input">
                      <input type="text"
                              class="form-control phone-number-input"
                              (input)="onPhoneInput(i, $event, row)"
                              placeholder="Enter phone number"
                              [(ngModel)]="row.phoneNumber"
                              [ngModelOptions]="{ standalone: true }"
                              [class.is-invalid]="row.touched && row.phoneNumber && row.isValidPhone === false"
                              (blur)="onPhoneBlur(i, row)"
                              data-testid="input-phone-number">
                        <div class="invalid-emailphone-feedback position_kc_step status-text-truncate" 
                          *ngIf="row.touched && row.phoneNumber && row.isValidPhone === false"
                          [matTooltip]="row.statusText || 'Please enter a valid phone number'"
                          matTooltipPosition="left">{{ row.statusText || 'Please enter a valid phone number' }}
                        </div>
                    </div>
                    </div>
                  </div>

                  <!-- Actions -->
                  <div class="col-3 d-flex align-items-center">
                    <!-- Preferred -->
                    <div class="add-row-start" *ngIf="row.isPreferred">
                      <a (click)="setPreferredPhone(i, false, true)" class="cursor-pointer" data-testid="lnk-preferred-phone">
                        <img src="../../../../assets/img/ArrowBlueIcon/Preffered blue.svg" alt="imgPreferred" class="width-preffred-icon">
                      </a>
                    </div>
                    <div class="add-row-start" *ngIf="!row.isPreferred">
                      <a (click)="setPreferredPhone(i, true, true)" class="cursor-pointer" data-testid="lnk-non-preferred-phone">
                        <img src="../../../../assets/img/ArrowBlueIcon/Preffered.svg" alt="imgPreferred" class="width-preffred-icon">
                      </a>
                    </div>
                    <div class="add-row-start" *ngIf="row.isFavourite">
                      <a (click)="setStartedPhone(i, false, true)" class="cursor-pointer" data-testid="lnk-favourite-phone">
                        <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" alt="imgstarticon" class="width-star-icon">
                      </a>
                    </div>
                    <div class="add-row-start" *ngIf="!row.isFavourite">
                      <a (click)="setStartedPhone(i, true, true)" class="cursor-pointer" data-testid="lnk-non-favourite-phone">
                        <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" alt="imgstarticon" class="width-star-icon">
                      </a>
                    </div>

                    <!-- Remove -->
                    <div class="add-row-btn">
                      <a (click)="removePhone(i,row)"
                          class="cursor-pointer ml-2"
                          *ngIf="phones.length > 1" data-testid="btn-remove-phone">
                        <img src="../../../../assets/img/client/filter-icon/delete.svg">
                      </a>
                    </div>

                    <!-- Add -->
                    <button *ngIf="i === phones.length - 1 && phones.length < getMaxAllowedPhones()"
                            class="cmn-inverse-btn ml-2"
                            (click)="addPhone(); $event.preventDefault()" data-testid="btn-add-phone-contact">
                      + Phone
                    </button>

                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm pt-1">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    LinkedIn  id
                  </h6>
                  <div class="col-4">
                    <div class="form-input-container">
                      <input type="text" class="form-control" placeholder="Enter LinkedIn profile id" (change)="ValidateContactLinkedinUrl();$event.preventDefault();"
                             name="linkedinprofileID" [(ngModel)]="contactDataModal.linkedinprofileID" autocomplete="off" data-testid="input-lnkdn-id"/>
                      <div *ngIf="contactDataModal.linkedinprofileID !='' && !ValidateContactLinked" class="invalid-feedback invalid">Please enter valid LinkedIn url</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Contact info end-->
          <!-- Physical Address -->
          <div class="physical-info-container">
            <h4 class="createcontact-section-title">Address</h4>
            <div *ngFor="let addressSet of addressSets; let i = index" class="createcontact-section-row">
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Type
                  </h6>
                  <div class="col-6">
                    <div class="form-select-container">
                      <ng-select [items]="addressTypeList[i]" [disabled]="addressSet.addressPoolMappingId > 0" class="cmn-ngselect" data-testid="drpdwn-address-type"
                                 bindLabel="addressTypeName"
                                 bindValue="addressTypeId"
                                 name="type{{i}}"
                                 [clearable]="true"
                                 (clear)="clearAddressType(addressSet)"
                                 [(ngModel)]="addressSet.addressTypeId"
                                 placeholder="Select type">
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Care of
                  </h6>
                  <div class="col-6">
                    <div class="form-input-container">
                      <input type="text" name="careof{{i}}" class="form-control" autocomplete="off" [(ngModel)]="addressSet.careof" data-testid="input-address-careof" placeholder="Enter care of" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                  <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
                    Address
                  </h6>

                  <div class="col-6">
                    <div class="form-select-container client-address-cmd client-address-footer-content Client-address-input-cmd form-select-address-container form-address-input-cmd form-select-address-shadow">
                      <ng-select class="cmn-ngselect" [items]="addressSet.fullAddressList" [disabled]="!addressSet.addressTypeId || addressSet.addressPoolMappingId > 0"
                                 bindLabel="addressLine" bindValue="addressPoolId" notFoundText='No address found' [virtualScroll]="true"
                                 [(ngModel)]="addressSet.addressPoolId" (ngModelChange)="checkAddressPool(addressSet)"
                                 [typeahead]="addressSet.addressInput$" typeToSearchText="Please enter 3 or more characters" (search)="onAddressSearch($event, i)" placeholder="Select address"
                                 name="fullAddress{{i}}" (focus)="onAddContactClear(i)" (clear)="onAddContactClear(i)" data-testid="drpdwn-address-full">
                        <ng-template ng-footer-tmp>
                          <div class="create-new" (click)="createContactAddressPopupOpen(i)" data-testid="btn-create-new-address">+Create address</div>
                        </ng-template>
                      </ng-select>

                    </div>
                  </div>
                  <div class="col-3" *ngIf="addressSet.addressPoolId && addressSet.addressTypeId">
                    <div class="d-flex align-items-center">
                      <div class="add-row-start" *ngIf="addressSets[i].isFavorite">
                        <a class="cursor-pointer">
                          <img src="../../../../assets/img/client/addClientIcons/starYellowIcon.svg" class="" />
                        </a>
                      </div>
                      <div class="add-row-start" *ngIf="!addressSets[i].isFavorite">
                        <a class="cursor-pointer" (click)="setAddressAsFavorite(i)" data-testid="lnk-non-favourite-address">
                          <img src="../../../../assets/img/client/addClientIcons/starNormalIcon.svg" class="" />
                        </a>
                      </div>
                      <div class="add-row-btn">
                        <button type="button" class="cmn-inverse-btn" mat-button [disabled]="activateButton" (click)="addAddressSet()" *ngIf="i == 0 && addressSets.length < addressTypes.length" data-testid="btn-add-address-set">
                          +
                          Address
                        </button>
                        <a class="cursor-pointer" data-testid="btn-remove-address" (click)="removeAddress(i)">
                          <img src="../../../../assets/img/client/filter-icon/delete.svg" class="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- Physical Address end-->
          <!-- custom fields -->
          <div class="custom-field-container">
            <h4 class="createcontact-section-title" *ngIf="cfqlconitem.length > 0">Custom fields </h4>
            <div class="" *ngFor="let cf of cfqlconitem; let i = index;">
              <div class="createcontact-section-row">
                <div class="form-group form-group-sm">
                  <div class="custom-row" [ngClass]="{'align-items-center':cf.fieldType!='Checkbox'}">
                    <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd" *ngIf="cf.fieldType=='Header' && i == 0">
                      {{cf.fieldLabel}} Custom fields
                    </h6>
                    <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd" *ngIf="cf.fieldType=='Header' && i != 0">
                      {{cf.fieldLabel}}
                    </h6>
                    <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd" *ngIf="cf.fieldType!='Header'">
                      {{cf.fieldLabel}} <span *ngIf="cf.helpText" class="ml-1 custom_fields_info" matTooltipClass="cmn-tooltip-template" matTooltip="{{cf.helpText}}">
                        <img src="../../../../assets/img/info-blue.svg" width="13px" loading="lazy" />
                      </span>
                    </h6>
                    <div class="col-5" [ngClass]="{'col-5':cf.fieldType!='Checkbox','col-9':cf.fieldType=='Checkbox'}">
                      <div class="form-input-container" *ngIf="cf.fieldType=='Text'">
                        <input type="text"
                               class="form-control"
                               [placeholder]="cf.placeHolder"
                               #value="ngModel"
                               [(ngModel)]="cf.value"
                               name="value-{{i}}"
                               autocomplete="off"
                               maxlength="50"
                               [readonly]="cf.isReadOnly" 
                               data-testid="input-custom-field"/>
                      </div>
                      <div class="form-select-container" *ngIf="cf.fieldType=='Dropdown List'">
                        <ng-select class="cmn-ngselect wthout-ellipsis-option"
                                   name="cfdropdown-{{i}}" [placeholder]="cf.placeHolder" bindLabel="dropvalue" bindValue="dropvalueId" [items]="cf.cfdropdown" (clear)="onClearCustomFieldDropdown(cf)"
                                   #cfdropdown="ngModel" [(ngModel)]="cf.value" [clearable]="cf.value" data-testid="drpdwn-custom-field">
                          <ng-template ng-label-tmp let-item="item">
                            <span [ngClass]="{'ng-select-custom-placeholder': !cf.value}">
                              {{item.dropvalue}}
                            </span>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-index="index">
                            <span [ngClass]="{'is-option-hidden': item.isHidden}"> {{item.dropvalue}}</span>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div *ngIf="cf.fieldType=='Checkbox'" class="d-flex flex-wrap">
                        <div class="cmn-checkbox mr-3 mb-2" *ngFor="let item of cf.cfdropdown; let checkIndex = index">
                          <input id="{{item.dropvalueId}}"
                                 type="checkbox"
                                 class="check_box_add_contact_css"
                                 value=""
                                 name="cfchkbox-{{i}}"
                                 [ngModelOptions]="{standalone: true}"
                                 [(ngModel)]="item.status"
                                 (change)="chkcustomqlConfield($event,i, checkIndex);" data-testid="chk-custom-field"/>
                          <label class="cmn-checkbox-text" for="cfchkbox-{{i}}">
                            <span class="checkbox-square"></span>
                            {{item.dropvalue}}
                          </label>
                        </div>
                      </div>
                      <div class="form-input-container" *ngIf="cf.fieldType=='Number'">
                        <input type="number"
                               class="form-control"
                               #value="ngModel"
                               [(ngModel)]="cf.value"
                               name="value-{{i}}"
                               autocomplete="off"
                               [placeholder]="cf.placeHolder"
                               [readonly]="cf.isReadOnly"
                               onkeypress="javascript: return event.target.value.length > 15 ? false : true"
                               onkeydown="javascript: return event.keyCode == 69 ? false : true" data-testid="input-custom-field-number"/>
                      </div>
                      <div class="form-input-container" *ngIf="cf.fieldType=='Link'">
                        <input type="url" class="form-control" #value="ngModel" [(ngModel)]="cf.value" name="value-{{i}}" autocomplete="off" [placeholder]="cf.placeHolder" [readonly]="cf.isReadOnly"
                               pattern="https?:\/\/(?:www\.)?[a-zA-Z0-9\-\.]+\.[a-z]{2,}(\/\S*)?"
                               (blur)="value.control.markAsTouched()" data-testid="input-custom-field-link"/>
                        <div *ngIf="value.invalid && value.touched" class="text-danger">
                          <div *ngIf="value.errors?.['pattern']">Enter a valid URL (e.g., https://example.com).</div>
                        </div>
                      </div>
                      <div class="form-datepicker-container cmn-material-datepicker" *ngIf="cf.fieldType=='Date'">
                        <mat-form-field floatLabel="never" appearance="standard">
                          <input class="cmn-mat-dtpicker-input" matInput
                                 #value="ngModel"
                                 [(ngModel)]="cf.value" [matDatepicker]="CfDatepicker"
                                 name="value-{{i}}" autocomplete="off" placeholder="dd/mm/yyyy" [disabled]="cf.isReadOnly != 'readonly' ? false : true" data-testid="datepkr-custom-field"/>
                          <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="CfDatepicker"></mat-datepicker-toggle>
                          <mat-datepicker panelClass="cmn-datepicker-ui"
                                          #CfDatepicker></mat-datepicker>
                          <mat-error class="cmn-material-datepicker-errormsg">
                            Please enter the date in dd/mm/yyyy
                          </mat-error>
                        </mat-form-field>
                        <!-- commented due to datepicker control change -->
                        <!-- <ejs-datepicker cssClass=''
                                        format='dd/MM/yyyy' [placeholder]='cf.placeholder'
                                        [readonly]="cf.isReadOnly"
                                        name="value-{{i}}" #value="ngModel"
                                        [(ngModel)]="cf.value" [showTodayButton]="false"
                                        openOnFocus='true' strictMode='true'></ejs-datepicker> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- custom endfields -->
        </div>
        <div class="cmn-modal-footer">
          <button type="submit" mat-button class="cmn-blue-btn" data-testid="btn-save-contact">{{buttontext}}</button>
          <button type="button" mat-button class="cmn-inverse-btn" (click)="cancelContactForm(addcontactForm);" data-testid="btn-cancel-contact">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</div>

<div bsModal #WarningPopupone="bs-modal" class="modal fade show bg_color" tabindex="-1" [config]="{ backdrop: 'static' }" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="overflow-y:hidden">
  <div class="modal-dialog cmn-modal-dsgn modal-dialog-centered" role="document">
    <form>
      <div class="col-12 p-0">
        <div class="cmn-warning-popup-container">
          <div class="modal-content no-border">
            <div class="cmn-modal-header">
              <h4 class="modal-header-title"><img src="../../../../assets/img/addclient/warningIcon.svg" /> Warning</h4>
            </div>
            <div class="cmn-modal-content">
              <p>All unsaved data will be lost</p>
              <p>Are you sure you want to leave?</p>
            </div>
            <div class="cmn-modal-footer">
              <button type="button" mat-button (click)="closeclient(true,addcontactForm)" class="cmn-inverse-btn mr-3" data-testid="btn-warning-popup-no">No</button>
              <button type="button" mat-button class="cmn-blue-btn" (click)="closeclient(false,addcontactForm)" data-testid="btn-warning-popup-yes">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>


<div bsModal #WarningPopup="bs-modal" class="modal fade show bg_color" tabindex="-1" [config]="{ backdrop: 'static' }" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="overflow-y:hidden">
  <div class="modal-dialog cmn-modal-dsgn modal-dialog-centered" role="document">
    <form>
      <div class="col-12 p-0">
        <div class="cmn-warning-popup-container">
          <div class="modal-content no-border">
            <div class="cmn-modal-header">
              <h4 class="modal-header-title"><img src="../../../../assets/img/addclient/warningIcon.svg" /> Warning</h4>
            </div>
            <div class="cmn-modal-content">
              <p>Contact Information is not saved.</p>
              <p>Are you sure you want to leave?</p>
            </div>
            <div class="cmn-modal-footer">
              <button type="submit" mat-button (click)="WarningPopuponeClose()" class="cmn-inverse-btn mr-3" data-testid="btn-warning-popup-no">No</button>
              <button type="button" mat-button class="cmn-blue-btn" (click)="waringpopuponeyes()" data-testid="btn-warning-popup-yes">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #generateFormPopupRef>
  <app-ni-generateform-popup [sourceComponent]="'createContactComponent'" [changedPhysicalAddress]="changedPhysicalAddress" [contactData]="contactData" [contactTempId]="contactTempId" [selectedContact]="selectedContact" [changedNewPhyAddress]="changedNewPhyAddress" [oldPhysicalAddressId]="oldPhysicalAddressId" [newPhyAddressId]="newPhyAddressId" [newPhysicalAddressLine]="newPhysicalAddressLine" [newPhyAddresscareOf]="newPhyAddresscareOf"></app-ni-generateform-popup>
</ng-template>


<ng-template #CreateNewAddress>
  <form #createAddressForm="ngForm" (ngSubmit)="addAddress()">
    <div class="col-sm-12 p-0">
      <div class="">
        <div class="cmn-modal-header">
          <h4 class="modal-header-title">Create address</h4>
        </div>
        <div class="cmn-modal-content">
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Unit</h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Unit" [(ngModel)]="addressData.unit" placeholder="Enter unit" data-testid="input-address-unit" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Address line 1<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Addressline1" [(ngModel)]="addressData.addressLine1" placeholder="Enter address line 1" required #addLine="ngModel" [class.is-invalid]="addLine.invalid && (addLine.dirty || addLine.touched)" data-testid="input-address-line1" />
                  <div *ngIf="addLine.invalid && (addLine.dirty || addLine.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                    This field is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Address line 2</h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Addressline2" [(ngModel)]="addressData.addressLine2" placeholder="Enter address line 2" data-testid="input-address-line2" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Suburb<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Suburb" [(ngModel)]="addressData.suburb" placeholder="Enter suburb" required #suburb="ngModel" [class.is-invalid]="suburb.invalid && (suburb.dirty || suburb.touched)" data-testid="input-address-suburb" />
                </div>
                <div *ngIf="suburb.invalid && (suburb.dirty || suburb.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">State<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-select-container">
                  <ng-select [items]="stateList" class="cmn-ngselect" data-testid="drpdwn-address-state-contact"
                             bindLabel="name"
                             bindValue="stateId"
                             [clearable]="true" name="State"
                             placeholder="Select state"
                             [(ngModel)]="selectedStateId"
                             required
                             #state="ngModel"
                             [class.is-invalid]="state.invalid && (state.dirty || state.touched)">
                  </ng-select>
                </div>
                <div *ngIf="state.invalid && (state.dirty || state.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>

          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Post code<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-input-container">
                  <input type="text" class="form-control" autocomplete="off" name="Postcode" [(ngModel)]="addressData.postcode" placeholder="Enter postcode" required #postcode="ngModel" [class.is-invalid]="postcode.invalid && (postcode.dirty || postcode.touched)" data-testid="input-address-postcode" />
                </div>
                <div *ngIf="postcode.invalid && (postcode.dirty || postcode.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="custom-row align-items-center">
              <h6 class="cmn-form-label text-left mb-0 col-3 left-aignment-address-labels">Country<span class="error-text">*</span></h6>
              <div class="col-8">
                <div class="form-select-container">
                  <ng-select [items]="contactcountries" class="cmn-ngselect" data-testid="drpdwn-address-country-contact"
                             bindLabel="name"
                             bindValue="countryId"
                             [clearable]="true" name="Country"
                             placeholder="Select country"
                             [(ngModel)]="selectedCountryId"
                             (ngModelChange)="onCountryChange($event)"
                             required
                             #country="ngModel"
                             [class.is-invalid]="country.invalid && (country.dirty || country.touched)">
                  </ng-select>
                </div>
                <div *ngIf="country.invalid && (country.dirty || country.touched)" class="invalid-feedback invalid entity-type-cmd error-messge-kc">
                  This field is required
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="cmn-modal-footer">
          <button type="submit" mat-button class="cmn-blue-btn" [disabled]="!createAddressForm.form.valid" data-testid="btn-add-address">Add</button>
          <button type="button" class="cmn-inverse-btn" mat-button (click)="createcontactAddressPopupclose()" data-testid="btn-cancel-create-address">Cancel</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- Common datepicker template -->
<ng-template #commonDatepickerTemplate let-label="label" let-name="name" let-value="value" let-min="min" let-max="max" let-dataTestid="dataTestid" let-changeHandler="changeHandler" let-maxValueName="maxValueName">
  <div class="form-group form-group-sm">
    <div class="custom-row align-items-center">
      <h6 class="cmn-form-label text-left mb-0 col-3 padding-left-alignment-cmd">
        {{ label }}
      </h6>
      <div class="col-3">
        <div class="form-datepicker-container cmn-material-datepicker">
          <mat-form-field floatLabel="never" appearance="standard">
            <input class="cmn-mat-dtpicker-input" matInput [name]="name" autocomplete="off" placeholder="dd/mm/yyyy" [attr.data-testid]="dataTestid" [attr.aria-label]="label"
                   [min]="min ? (contactDataModal?.[min] || null) : null" [max]="contactDataModal?.[maxValueName] ? contactDataModal?.[maxValueName] : (max || null)" [(ngModel)]="contactDataModal[name]" #datePickerRef="ngModel" (dateChange)="changeHandler ? checkOnchangefield() : null" [matDatepicker]="picker" />
            <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker panelClass="cmn-datepicker-ui" #picker></mat-datepicker>

            <!-- Error 1: Generic invalid date format -->
            <mat-error class="cmn-material-datepicker-errormsg"
                       *ngIf="(!min && datePickerRef?.hasError('matDatepickerParse')) || (!datePickerRef?.hasError('matDatepickerMax') && (!min || !datePickerRef?.hasError('matDatepickerMin')))">
              Please enter the date in dd/mm/yyyy
            </mat-error>

            <!-- Error 2: Invalid due to range (min/max) -->
            <mat-error class="cmn-material-datepicker-errormsg" *ngIf="datePickerRef?.hasError('matDatepickerMax') || (min && datePickerRef?.hasError('matDatepickerMin'))">
              Please enter a valid {{ label | lowercase }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Bulk Email Update-->
<ng-template #BulkEmailUpdate>
  <div class="bulk-email-update-container">
    <form class="col-sm-12 p-0" #BulkUpdateEmailForm="ngForm" novalidate>

      <div class="cmn-modal-header">
        <h4 class="modal-header-title">
          Bulk email update
        </h4>
      </div>

      <div class="cmn-modal-content">

        <!-- STEP 1 -->
        <div class="bulkaddress-content" *ngIf="modalScreen === 1">

          <p class="blk-updt-desc">
            We have identified the Clients/Contacts associated with the updated emails.
            Please select the Clients/Contacts you wish to update:
          </p>

          <!-- LOOP GROUPS -->
          <div *ngFor="let group of bulkEmailGroups; let gIndex = index">

            <!-- Group Heading -->
            <h5 class="blk-updt-frm-to" *ngIf="group.toEmail !== 'Removed'">
              From "{{ group.fromEmail }}" → To "{{ group.toEmail }}"
            </h5>

            <h5 class="blk-updt-frm-to" *ngIf="group.toEmail === 'Removed'">
              Removed - "{{ group.fromEmail }}"
            </h5>

            <!-- Select All Per Group -->
            <div class="cmn-checkbox mb-2">
              <input type="checkbox"
                     class="checkbox_status cursor-pointer"
                     id="checkAllEmail-{{gIndex}}"
                     [(ngModel)]="group._isCheckAll"
                     name="checkAllEmail-{{gIndex}}"
                     (ngModelChange)="toggleAllEmails(group)"
                     data-testid="chk-select-all-emails" />

              <label class="cmn-checkbox-text"
                     for="checkAllEmail-{{gIndex}}">
                <span class="checkbox-square"></span>
                {{group._isCheckAll ? 'Unselect' : 'Select'}} all
              </label>
            </div>

            <!-- Entities inside group -->
            <ng-container *ngFor="let entity of group.entities; let i = index">

              <div class="cmn-checkbox mb-2">
                <input type="checkbox"
                       class="checkbox_status cursor-pointer"
                       id="checkEmail-{{gIndex}}-{{i}}"
                       name="checkEmail-{{gIndex}}-{{i}}"
                       [(ngModel)]="entity._isChecked"
                       (ngModelChange)="updateCheckAllStatus(group)"
                       data-testid="chk-email">

                <label class="cmn-checkbox-text"
                       for="checkEmail-{{gIndex}}-{{i}}" style="display: flex; align-items: flex-start; gap: 8px;">
                  <span class="checkbox-square" style="flex-shrink: 0;"></span>


                  {{entity.name}} | {{entity.entityType}} | {{entity.emailTypeName}}
                </label>
              </div>

            </ng-container>

            <hr />

          </div>

        </div>

      </div>


      <!-- FOOTER -->
      <div class="cmn-modal-footer">

        <button mat-button type="button"
                class="cmn-blue-btn"
                *ngIf="modalScreen === 1"
                (click)="onSubmitBulkEmailUpdate()" data-testid="btn-bulk-email-update">
          Update
        </button>

        <button type="button"
                class="cmn-inverse-btn"
                (click)="onCancel()" data-testid="btn-bulk-email-cancel">
          Cancel
        </button>

      </div>

    </form>
  </div>
</ng-template>

<!-- Bulk Email Update-->
